var LocalizationHelper = /** @class */ (function () {
    function LocalizationHelper() {
    }
    LocalizationHelper.l = function (localizationService, localizationSourceName, key) {
        var args = [];
        for (var _i = 3; _i < arguments.length; _i++) {
            args[_i - 3] = arguments[_i];
        }
        var localizedText = localizationService.localize(key, localizationSourceName);
        if (!localizedText) {
            localizedText = key;
        }
        if (!args || !args.length) {
            return localizedText;
        }
        if (args.length === 1 && Array.isArray(args[0])) {
            args[0].unshift(localizedText);
            return abp.utils.formatString.apply(this, args[0]);
        }
        else {
            args.unshift(localizedText);
            return abp.utils.formatString.apply(this, args);
        }
    };
    return LocalizationHelper;
}());
export { LocalizationHelper };
